jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

AOS.init();

function goToMainContent() {
  const $main = $("#main");
  if ($main.length) {
    $("html, body").animate({ scrollTop: $main.offset().top }, 500);

    if (!$main.attr("tabindex")) {
      $main.attr("tabindex", "-1");
    }

    $main.focus();
  }
}

$("li.level1 a.level1").on("mouseenter", function () {
  $("li.level1").removeClass("open-navi");
  $(this).parent().addClass("open-navi");
});

$("#closeMenu").on("click", function () {
  $("li.level1").removeClass("open-navi");
});

const $toggleBtn = $("#menuToggle");
const $closeBtn = $("#closeMenu");
const $navWrapper = $("#mainNavigation");

function getFocusableElements($navWrapper) {
  return $navWrapper
    .find("a, button, input, textarea, select, [tabindex]")
    .filter(":not([disabled])");
}

function disableTabbing($navWrapper) {
  getFocusableElements($navWrapper).each(function () {
    const $el = $(this);
    $el.attr("data-tabindex", $el.attr("tabindex") || "");
    $el.attr("tabindex", -1);
  });
}

function enableTabbing($navWrapper) {
  getFocusableElements($navWrapper).each(function () {
    const $el = $(this);
    const original = $el.attr("data-tabindex");
    if (original !== undefined) {
      $el.attr("tabindex", original);
      $el.removeAttr("data-tabindex");
    } else {
      $el.removeAttr("tabindex");
    }
  });
}

function trapFocusOnce($navWrapper) {
  const focusableSelector =
    "a, button, input, textarea, select, [tabindex]:not([tabindex='-1'])";

  $navWrapper.on("keydown", function (e) {
    if (e.key !== "Tab" && e.keyCode !== 9) return;

    const $focusableEls = $navWrapper
      .find(focusableSelector)
      .filter(":not([disabled])");
    const first = $focusableEls[0];
    const last = $focusableEls[$focusableEls.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
}
trapFocusOnce($navWrapper);

function openNav() {
  $toggleBtn.attr("aria-expanded", "true");
  $toggleBtn.attr("aria-label", "Close main navigation");
  $navWrapper.removeAttr("hidden").attr("aria-hidden", "false");
  enableTabbing($navWrapper);
  $closeBtn.focus();
  $("#mainNavigation").addClass("navi-open");
  $("body").addClass("navi-open");
}

function closeNav() {
  $toggleBtn.attr("aria-expanded", "false");
  $toggleBtn.attr("aria-label", "Open main navigation");
  $navWrapper.attr("hidden", "").attr("aria-hidden", "true");
  disableTabbing($navWrapper);
  $toggleBtn.focus();
  $("#mainNavigation").removeClass("navi-open");
  $("body").removeClass("navi-open");
}

$(document).on("keydown", function (e) {
  if (e.key === "Escape" || e.keyCode === 27) {
    if ($toggleBtn.attr("aria-expanded") === "true") {
      closeNav();
    }
  }
});

$toggleBtn.on("click", function () {
  var isOpen = $toggleBtn.attr("aria-expanded") === "true";
  isOpen ? closeNav() : openNav();
});

$closeBtn.on("click", closeNav);

disableTabbing($navWrapper);

// Detect if device is touch capable
const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

// Keyboard toggle (Tab + Enter/Space)
$("li.level1.sublevels > a").on("keydown", function (e) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    toggleSubmenu($(this).closest("li.level1.sublevels"));
  }
});

// Click toggle for touch devices only
if (isTouch) {
  $("li.level1.sublevels > a").on("click", function (e) {
    e.preventDefault();
    toggleSubmenu($(this).closest("li.level1.sublevels"));
  });
}

// Back button (keyboard + touch)
$("ul.level2 .back-one").on("click keydown", function (e) {
  if (e.type === "click" || e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    e.stopPropagation();

    const $ul2 = $(this).closest("ul.level2");
    const $level1 = $ul2.closest("li.level1");
    const $img = $level1.children(".img-wrapper");

    $ul2.removeClass("open");
    $img.removeClass("open");
    updateLevel2ScrollState();
  }
});

// Auto-close submenu on focus out (keyboard users)
$("li.level1.sublevels").on("focusout", function () {
  const $li = $(this);
  const $ul2 = $li.children("ul.level2");
  const $img = $li.children(".img-wrapper");

  setTimeout(() => {
    if (!$li.find(":focus").length) {
      $ul2.removeClass("open");
      $img.removeClass("open");
      updateLevel2ScrollState();
    }
  }, 0);
});

function updateLevel2ScrollState() {
  const hasOpenLevel2 = $("ul.level2.open").length > 0;
  $("#mainNavigation").toggleClass("level2-open", hasOpenLevel2);
}

// Function to toggle submenu
function toggleSubmenu($li) {
  const $ul2 = $li.children("ul.level2");
  const $img = $li.children(".img-wrapper");

  // Close all others
  $("li.level1.sublevels")
    .not($li)
    .each(function () {
      $(this).children("ul.level2").removeClass("open");
      $(this).children(".img-wrapper").removeClass("open");
    });

  // Toggle current
  $ul2.toggleClass("open");
  $img.toggleClass("open");
  updateLevel2ScrollState();
}

var searchWrapper = $(".search-form-wrapper");
var searchInput = $(".search-form-wrapper .search-input");
var searchIcon = $(".search-toggle");
searchIcon.on("click", function () {
  searchWrapper.toggleClass("show");

  if (searchWrapper.hasClass("show")) {
    searchInput.focus();
    searchIcon.attr("aria-expanded", "true");
  } else {
    searchIcon.attr("aria-expanded", "false");
    searchInput.blur();
  }
});

$(
  ".hamburger, .buy-tickets a, .lang-navi a, .slideup-diagonal-text, .arrow-right"
).each(function () {
  var originalText = $(this)
    .contents()
    .filter(function () {
      return this.nodeType === 3;
    })
    .text()
    .trim();

  if (originalText) {
    $(this).html(
      '<div class="slide-in-bottom"><span aria-hidden="true" data-hover="' +
        originalText +
        '">' +
        originalText +
        "</span></div>"
    );
  }
});

function wrapTextWithAnimation(selector, iconClass) {
  $(selector).each(function () {
    var originalText = $(this)
      .contents()
      .filter(function () {
        return this.nodeType === 3;
      })
      .text()
      .trim();

    if (originalText) {
      $(this).html(
        '<div class="slide-in-bottom"><span aria-hidden="true" data-hover="' +
          originalText +
          '">' +
          originalText +
          '<div class="' +
          iconClass +
          '"></div>' +
          "</span></div>"
      );
    }
  });
}

wrapTextWithAnimation(".btn-puppet", "icon-more");
wrapTextWithAnimation(".btn-primary", "icon-more");
wrapTextWithAnimation(".btn-secondary", "icon-more-orange");
wrapTextWithAnimation(".btn-transparent", "icon-more-dark");
wrapTextWithAnimation(".slideup", "icon-more-dark");
wrapTextWithAnimation(".lang-active", "icon-arrow-down");

function slideUpDiagonal(selector, iconClass) {
  $(selector).each(function () {
    var textNode = $(this)
      .contents()
      .filter(function () {
        return this.nodeType === 3 && this.nodeValue.trim().length > 0;
      })
      .get(0);

    if (textNode) {
      var originalText = textNode.nodeValue.trim();

      // Clear the current content
      $(this).empty();

      // Create the icon span
      var $iconSpan = $("<span>", {
        class: iconClass,
        "aria-hidden": "true",
      });

      // Append the icon and the original text
      $(this)
        .append($iconSpan)
        .append(" " + originalText);
    }
  });
}

slideUpDiagonal(
  ".slideup-diagonal-editor",
  "icon-arrow-diagonal-circle orange"
);

$(document).on("click", function (event) {
  if (!$(event.target).closest(".lang, .lang-active").length) {
    $(".lang").removeClass("open-lang");
  }
});

$(".lang-active").on("click", function (event) {
  event.stopPropagation();
  $(".lang").toggleClass("open-lang");

  if ($(".lang").hasClass("open-lang")) {
    $(".lang-active").attr("aria-expanded", "true");
  } else {
    $(".lang-active").attr("aria-expanded", "false");
  }
});

$("#newsletter-subscribe").on("submit", function (e) {
  e.preventDefault();
  var form = $(this)[0];

  if (form.checkValidity() === false) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  var $submitBtn = $(this).find("button[type=submit]");
  var $loader = $(".spin-loader");

  // disable + show loader
  $submitBtn.prop("disabled", true);
  $loader.css("display", "flex");

  $.ajax({
    type: "post",
    url: $(this).attr("action"),
    data: $(this).serialize(),
    success: function (data) {
      $("#submitedEmail").html($("#subscribeEmail").val());
      $("#newsletterModal").modal();
    },
    complete: function () {
      // re-enable + hide loader
      $submitBtn.prop("disabled", false);
      $loader.css("display", "none");
    },
  });
});

$("#contact_form").on("submit", function (e) {
  var form = $(this)[0];
  var $form = $(this);

  if ($form.hasClass("submitting")) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  if (form.checkValidity() === false) {
    return true;
  }

  $form.addClass("submitting");
  $form.attr("aria-busy", "true");
  $form.find("button[type=submit]").prop("disabled", true);
});

$('iframe[src*="google.com/maps"]').attr({
  "aria-hidden": "true",
  tabindex: "-1",
  title: "Google Maps lokacija",
});

(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              $(form).addClass("has-errors");
            } else {
              $(form).removeClass("has-errors");
              $(form).addClass("submitting");
              form.submit();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();

if ($("#main-carousel").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var main = new Splide("#main-carousel", {
      type: "fade",
      rewind: true,
      pagination: false,
      height: 496,
      breakpoints: {
        992: {
          height: "auto",
        },
      },
      arrows: true,
    }).mount();

    var thumbnails;
    var isThumbnailActive = false;

    function handleResize() {
      const shouldShowThumbnails = window.innerWidth > 992;

      if (shouldShowThumbnails && !isThumbnailActive) {
        thumbnails = new Splide("#thumbnail-carousel", {
          fixedWidth: 193,
          fixedHeight: 168,
          height: 496,
          gap: 8,
          direction: "ttb",
          rewind: true,
          arrows: false,
          pagination: false,
          isNavigation: true,
        });

        main.sync(thumbnails);
        thumbnails.mount();
        isThumbnailActive = true;
      } else if (!shouldShowThumbnails && isThumbnailActive) {
        thumbnails.destroy();
        isThumbnailActive = false;
      }
    }

    // Initial check
    handleResize();

    // Listen to window resize
    window.addEventListener("resize", handleResize);
  });
}
